// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.insert_column_button__button_dd60c198 {
  display: flex;
  width: 2.5rem;
  height: 2.5rem;
  padding: 0;
  border: none;
  background-color: transparent;
}
.insert_column_button__button_dd60c198:hover .insert_column_button__icon_dd60c198 {
  width: 1.167rem;
  height: 1.167rem;
  border-color: #6185a6;
  color: #6185a6;
}
.insert_column_button_dd60c198.is-sticky_dd60c198 {
  z-index: 61;
}
.insert_column_button__icon_dd60c198 {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
  width: 1rem;
  height: 1rem;
  border-radius: 0.167rem;
  border: 0.084rem solid #84919b;
  color: #84919b;
  background-color: #f8f9fa;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"insert_column_button__button": `insert_column_button__button_dd60c198`,
	"insert_column_button__icon": `insert_column_button__icon_dd60c198`,
	"insert_column_button": `insert_column_button_dd60c198`,
	"is-sticky": `is-sticky_dd60c198`
};
export default ___CSS_LOADER_EXPORT___;
